// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disabled[data-v-6e3a5bde] {\n  background-color: #d5d5da !important;\n}\n.accepted-cards[data-v-6e3a5bde] {\n  display: flex;\n}\n.check-refund[data-v-6e3a5bde] {\n  padding: 1rem 0rem;\n  border-top: 1px solid #d5d5da;\n  border-bottom: 1px solid #d5d5da;\n}", ""]);
// Exports
module.exports = exports;
